import React from 'react'
import {graphql} from "gatsby";
import parse from 'html-react-parser';

const TitleHeader = ({ title, theme }) => {
  return (
    <section className={`title-header${theme ? ` ${theme}` : ''}`}>
        <div className='title-header__inner'>
            {title && <h1 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h1>}
        </div>
    </section>
  )
}

export default TitleHeader

export const query = graphql`
  fragment TitleHeaderProps on DatoCmsTitleHeader {
    ... on DatoCmsTitleHeader {
      title
    }
  }
`